import SiteStatus from './SiteStatus';

export default SiteStatus;
